function setLocale(locale) {
  document.cookie = "locale=" + locale + ";path=/";
  document.location.reload();
}

window.addEventListener('tucareer:select-language', function (event) {
  const locale = event.target.getAttribute('data-locale')
  if (locale) {
    setLocale(locale)
  }
})